<template>
  <div class="cady-notification">
    <div
      v-html="renderMarkdownToHtml(notification.fields.body)"
      class="cady-notification__body text-center px-3 px-md-0"
    />
    <div
      v-if="notification.fields.isDismissible"
      class="cady-notification__dismiss-cta"
    >
      <button
        type="button"
        class="btn btn-link cady-notification__dismiss-btn"
        @click="$emit('dismiss')"
      >
        <FontAwesomeIcon
          :icon="appIcons.faTimes"
          size="xs"
        />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

import useAppIcons from '@/composables/appIcons'
import { renderMarkdownToHtml } from '@/composables/contentful'

import type { ContentfulEntry } from '#contentful/ContentfulEntrySys'
import type { ContentfulNotification } from '#contentful/ContentfulNotification'

export default defineComponent({
  name: 'CadyNotification',
  setup() {
    return {
      ...useAppIcons(),
      renderMarkdownToHtml
    }
  },
  props: {
    notification: {
      type: Object as PropType<ContentfulEntry<ContentfulNotification>>,
      required: true
    }
  }
})
</script>

<style scoped lang="scss">
.cady-notification {
  &:deep(p) {
    margin: 0;
    padding: 0;
  }

  background: linear-gradient(90deg, #514c9a 0%, #ad4091 100%);
  color: white;
  line-height: 1.5rem;
  position: relative;

  &__body {
    padding: 0.5rem 0;
  }

  &__dismiss {
    &-cta {
      position: absolute;
      top: 0;
      right: 0;
    }

    &-btn {
      color: white;
      padding: 0.5rem;
      font-size: 1.25rem;
      line-height: 1;
      opacity: 0.75;

      &:hover {
        color: white;
        text-decoration: none;
        opacity: 1;
      }
    }
  }
}
</style>
